import { toError } from './utilities';

export default class ErrorWithContext extends Error {
  private error: Error;

  constructor(
    error: unknown,
    public context: Record<string, any>
  ) {
    super();
    this.error = toError(error);
  }

  get message() {
    return this.error.message;
  }

  get stack() {
    return this.error.stack;
  }
}
